
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/broadband'],
      disableBreadcrumb: true,
      metaTagOptions: { image: 'broadband' },
      product: 'broadband',
      searchPath: 'broadband/searches'
    },
    middleware: ['breadcrumbs', 'pages/broadband/index', 'jumbotron', 'meta-tags'],
    data () {
      return {
        basePath: 'compare-tv-broadband-phone',
        guidePath: this.localePath('/guides/broadband-phone-tv/quickstart-guide-how-to-get-the-best-value-broadband-tv-and-phone-deals-on-bonkers-ie/'),
        nextPage: this.localePath('/compare-tv-broadband-phone/your-results/')
      };
    },
    mounted () {
      this.$store.dispatch('matomo/trackIndexPageViewed', { name: 'Broadband index page viewed' });
      this.removeCookies();
      this.$store.commit('search/reset', { type: 'broadband' });
    },
    methods: {
      removeCookies () {
        this.$cookies.remove('bonkers-ie-broadband-capture-point');
        this.$cookies.remove('bonkers-ie-broadband-search');
      }
    }
  };
